import React, { useState } from 'react';
import { supabase, isSupabaseConfigured } from '../services/supabaseClient';
import { insertCertificate } from '../services/supabaseCertificates';

const TestSupabase = () => {
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const testConnection = async () => {
    setResult(null);
    setError(null);
    
    try {
      console.log('Testing Supabase configuration...');
      console.log('Is configured:', isSupabaseConfigured());
      console.log('Supabase client:', supabase);
      
      if (!supabase) {
        throw new Error('Supabase client is null');
      }

      // Test a simple query
      console.log('Attempting to query certificates table...');
      const { data, error: queryError } = await supabase
        .from('certificates')
        .select('*')
        .limit(1);

      if (queryError) {
        throw queryError;
      }

      setResult({ success: true, message: 'Connection successful!', data });
      console.log('✓ Supabase connection test successful:', data);
    } catch (e) {
      console.error('❌ Supabase connection test failed:', e);
      setError({
        message: e.message,
        code: e.code,
        details: e.details,
        hint: e.hint
      });
    }
  };

  const testInsert = async () => {
    setResult(null);
    setError(null);
    
    try {
      const testRecord = {
        institution: 'Test Institution',
        institutionId: null,
        studentName: 'Test Student',
        rollNumber: 'TEST123',
        certificateType: 'Test',
        fileName: 'test.pdf',
        fileHash: 'test_' + Date.now(),
        cid: 'QmTest' + Date.now(),
        ipfsUrl: 'https://ipfs.io/ipfs/QmTest',
        uploadDate: new Date().toISOString(),
        anchorTx: null,
        anchorUrl: null
      };

      console.log('Testing certificate insert...', testRecord);
      const insertResult = await insertCertificate(testRecord);
      console.log('Insert result:', insertResult);
      
      setResult({ success: true, message: 'Insert successful!', data: insertResult });
    } catch (e) {
      console.error('❌ Insert test failed:', e);
      setError({
        message: e.message,
        code: e.code,
        details: e.details,
        hint: e.hint
      });
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-2xl font-bold mb-6">Supabase Connection Test</h1>
        
        <div className="space-y-4 mb-6">
          <div>
            <strong>Configuration Status:</strong>
            <div className="mt-2 p-4 bg-gray-50 rounded">
              <p>Configured: {isSupabaseConfigured() ? '✓ Yes' : '✗ No'}</p>
              <p>Client initialized: {supabase ? '✓ Yes' : '✗ No'}</p>
              <p>URL: {process.env.REACT_APP_SUPABASE_URL ? '✓ Set' : '✗ Not set'}</p>
              <p>Anon Key: {process.env.REACT_APP_SUPABASE_ANON_KEY ? '✓ Set' : '✗ Not set'}</p>
            </div>
          </div>

          <button
            onClick={testConnection}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
          >
            Test Connection (Query)
          </button>

          <button
            onClick={testInsert}
            className="w-full bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
          >
            Test Insert
          </button>
        </div>

        {result && (
          <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded">
            <h3 className="font-bold text-green-800 mb-2">Success!</h3>
            <pre className="text-sm overflow-auto">{JSON.stringify(result, null, 2)}</pre>
          </div>
        )}

        {error && (
          <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded">
            <h3 className="font-bold text-red-800 mb-2">Error</h3>
            <pre className="text-sm overflow-auto">{JSON.stringify(error, null, 2)}</pre>
          </div>
        )}

        <div className="mt-6 pt-6 border-t">
          <h3 className="font-bold mb-2">Instructions:</h3>
          <ol className="list-decimal list-inside space-y-2 text-sm text-gray-700">
            <li>Make sure your Supabase credentials are set in .env</li>
            <li>Ensure the 'certificates' table exists in Supabase</li>
            <li>Check that RLS policies allow inserts</li>
            <li>Open browser console for detailed logs</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TestSupabase;
